// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"69d547ab","453":"2e881017","882":"81e4557f","916":"50aab2f4"}[chunkId] + ".chunk.js";
};